import { InputNumber as AntdInputNumber } from '@empglabs/backoffice-ui-kit'

const InputNumber = props => {
  return <AntdInputNumber {...props} />
}

export default InputNumber
